import React from 'react';
import cn from '../../lib/cn';
import { brand } from '../../data/media';
import site from '../../data/site';

/**
 * The company lockup: the sunrise mark beside a typeset wordmark.
 *
 * The wordmark is set in type rather than shipped as an image so it stays
 * crisp at every size and remains selectable text. `tone` flips it for use on
 * the dark footer and the transparent-over-hero header.
 */
export function Logo({ tone = 'dark', className, showTagline = true, markSize = 44 }) {
  const wordTone = tone === 'light' ? 'text-canvas' : 'text-vermilion-600';
  const subTone = tone === 'light' ? 'text-canvas/70' : 'text-ink-600';
  const tagTone = tone === 'light' ? 'text-champagne-300' : 'text-champagne-500';

  return (
    <span className={cn('flex items-center gap-3', className)}>
      <img
        src={brand.mark}
        alt=""
        width={markSize}
        height={markSize}
        className="shrink-0"
        style={{ width: markSize, height: markSize }}
      />
      <span className="flex flex-col leading-none">
        {showTagline && (
          <span className={cn('mb-1 hidden text-[0.5rem] uppercase tracking-mega sm:block', tagTone)}>
            {site.tagline}
          </span>
        )}
        <span className={cn('font-sans text-[1.15rem] font-semibold leading-none tracking-[0.01em]', wordTone)}>
          RAJENDRA
        </span>
        <span className={cn('mt-1 font-sans text-[0.55rem] font-medium uppercase tracking-[0.26em]', subTone)}>
          Jewellers Pvt. Ltd.
        </span>
      </span>
    </span>
  );
}

export default Logo;
